import isMobile from 'ismobilejs';

function dynamicImportDesktop () {
  return import(/* webpackChunkName: "desktop" */ './desktopIndex');
}

if (
  isMobile().phone &&
  process.env.NODE_ENV !== 'development' &&
  process.env.NODE_ENV !== 'test' &&
  window.location.pathname.indexOf('mobile') === -1
) {
  // Redirect to mobile
  const pathnameLastChar = window.location.pathname.slice(-1);
  if (pathnameLastChar === '/') {
    window.location.pathname = `${window.location.pathname}mobile`;
  } else {
    window.location.pathname = `${window.location.pathname}/mobile`;
  }

} else {
  dynamicImportDesktop();
}